
<template>
  <div>
    <!--Intro -->
    <section class="section-shaped my-0">
      <div
        class="shape bg-gradient-isabl shape-skew"
        style="height: 90%"
      ></div>
      <div
        class="shape-container d-flex"
        style="padding-top: 8rem;"
      >
        <div class="col px-0">
          <div class="row">
            <div class="offset-lg-1 col-lg-10">
              <div class="row flex-row">
                <div class="col-lg-6 px-5 text-center text-white">
                  <h1 class="display-1 text-white mr-4 d-md-inline-block">
                    <a href>
                      <img
                        target="_blank"
                        :href="links.onlineDemo"
                        src="https://user-images.githubusercontent.com/7906289/45718714-09330200-bb6c-11e8-8a60-5da580086a5f.png"
                        alt="logo"
                        height="40"
                        class="pb-2 mr-2"
                      />
                    </a>
                    Isabl Platform
                  </h1>
                  <!-- <h3 class="text-white d-md-inline-block mb-3">Scalable precision medicine.</h3> -->
                  <p class="lead">
                    Process multimodal patient data
                    <a
                      href="https://bmcbioinformatics.biomedcentral.com/articles/10.1186/s12859-020-03879-7"
                    >at scale.</a>
                  </p>
                  <div
                    class="btn-wrapper text-center mb-3"
                    style="z-index: 9999 !important"
                  >
                    <base-button
                      tag="a"
                      :href="links.onlineDemo"
                      class="mb-3 mx-2"
                      type="primary"
                      target="_blank"
                    >
                      <font-awesome-icon
                        icon="magic"
                        class="mr-2"
                      />Try Isabl Now
                    </base-button>
                    <base-button
                      target="_blank"
                      tag="a"
                      :href="links.requestAccess"
                      class="mb-3 mx-2"
                      type="white"
                      icon="ni ni-email-83"
                    >Request an Instance</base-button>
                  </div>
                </div>
                <div class="col-lg-6">
                  <a
                    target="_blank"
                    :href="links.onlineDemo"
                  >
                    <img
                      width="90%"
                      class="img-center img-fluid"
                      tabindex="0"
                      src="https://user-images.githubusercontent.com/8843150/62553932-3cdb5100-b83e-11e9-858d-523366b30d53.png"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Great features -->
    <section
      class="section section-shaped my-0 overflow-hidden"
      style="margin-top: -410px !important; padding-top: 140px; z-index: -1"
    >
      <div
        class="shape shape-style-1 shape-skew"
        style="transform-origin: right; background-color: white"
      ></div>

      <!-- <div class="container col-lg-10">
        <div class="row row-grid">
          <div class="col-lg-12">
            <br />
            <div class="row row-grid text-center">
              <div class="col-lg-4">
                <font class="large-text text-purple">
                  <animated-number
                    :number="300"
                    :duration="30"
                  />TB
                </font>
                <h5 class="text-dark font-weight-bold">Of Multimodal Data</h5>
                <p class="text-dark mt-3">
                  An AI Ready Infrastructure.
                  Isabl supports the management of more than 300 TB of patient-centric data world-wide.
                </p>
              </div>

              <div class="col-lg-4">
                <font class="large-text text-purple">
                  <animated-number
                    :number="30"
                    :duration="100"
                  />K
                </font>
                <h5 class="text-dark font-weight-bold">Individuals</h5>
                <p
                  class="text-dark mt-3"
                >Isabl supports the management of more than 300 TB of patient-centric data world-wide.</p>
              </div>

              <div class="col-lg-4">
                <font class="large-text text-purple">
                  <animated-number
                    :number="250"
                    :duration="30"
                  />K
                </font>
                <h5 class="text-dark font-weight-bold">Analyses</h5>
                <p
                  class="text-dark mt-3"
                >Isabl supports the management of more than 300 TB of patient-centric data world-wide.</p>
              </div>
            </div>
          </div>
        </div>
      </div>-->

      <div class="container col-lg-10">
        <div class="row row-grid">
          <div class="col-lg-12">
            <div class="row row-grid text-center">
              <div class="col-lg-4">
                <div class="circle">
                  <font-awesome-icon
                    icon="plug"
                    color="white"
                    size="4x"
                    class="mt-5 text-purple"
                  />
                </div>
                <h5 class="text-dark font-weight-bold">Plug and Play</h5>
                <p class="text-dark mt-3">Install with Docker Compose and Python's package manager.</p>
              </div>

              <div class="col-lg-4">
                <div class="circle">
                  <font-awesome-icon
                    icon="handshake"
                    color="white"
                    size="4x"
                    class="mt-5 text-purple"
                  />
                </div>
                <h5 class="text-dark font-weight-bold">Advanced Integrations</h5>
                <p class="text-dark mt-3">Link institutional information systems with a RESTful API.</p>
              </div>

              <div class="col-lg-4">
                <div class="circle">
                  <font-awesome-icon
                    icon="cogs"
                    color="white"
                    size="4x"
                    class="mt-5 text-purple"
                  />
                </div>
                <h5 class="text-dark font-weight-bold">Run Anywhere</h5>
                <p
                  class="text-dark mt-3"
                >Isabl is agnostic to compute, storage, and data processing technologies.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Use Cases -->
    <section
      class="section section section-shaped my-0 overflow-hidden"
      style="margin-top: -5px !important; padding-top: 100px;"
    >
      <div
        class="shape shape-style-1 shape-skew"
        style="transform-origin: right; background-color: #F6F9FC"
      ></div>

      <div class="row justify-content-center row-grid mx-3">
        <div class="col-lg-9">
          <div
            class="row row-grid py-4 align-right"
            data-aos="fade-left"
            style="align-items: center"
          >
            <div
              class="col-lg-6 order-sm-0 order-md-0"
              style="vertical-align: middle;"
            >
              <h1 class="text-primary display-2">Run an interoperable architecture</h1>
              <p class="lead">
                Isabl Platform encapsulates decades of operational experience into a modern microservices architecture (i.e. RESTful API, Web SPA, and CLI). Our metadata model facilitates advanced processing and governance of NGS data, whilst guarantees a full audit trail of results provenance.
                <!-- Isabl's patient-centric infrastructure features an extensive and performant RESTful API, a blasting fast single page web application, and a portable command line client used for management and processing NGS data. -->
              </p>
            </div>
            <div class="col-lg-6 text-center order-sm-1 order-md-1 my-2">
              <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="6000"
                controls
                indicators
                background="transparent"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  img-src="https://user-images.githubusercontent.com/8843150/62482259-aeee6000-b782-11e9-9312-ed7111bf4c8d.png"
                ></b-carousel-slide>

                <b-carousel-slide
                  img-src="https://user-images.githubusercontent.com/8843150/62485025-874ec600-b789-11e9-9652-fbd504bec26f.png"
                ></b-carousel-slide>
              </b-carousel>
            </div>
          </div>

          <div
            class="row row-grid py-4"
            data-aos="fade-right"
          >
            <div class="col-lg-6 order-sm-0 order-md-1">
              <h1 class="text-primary display-2">Manage and process your data at scale</h1>
              <p
                class="lead"
              >Automatically import and process data across thousands of samples using Isabl CLI. Isabl applications enable metadata-driven deployment of your own pipelines into a compute environment of choice.</p>
            </div>

            <div class="col-lg-6 text-center order-sm-1 order-md-0">
              <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="null"
                controls
                indicators
                background="transparent"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <b-carousel-slide
                  img-src="https://docs.google.com/drawings/d/e/2PACX-1vRykiR6OMjBWUdextdPGjhSsMcaoMh2Gy5T7Gi2M5Q8Ndhe3XjBHIodAAT2mAkF1CS1IWY-iZ3JQXjP/pub?w=1138&h=701"
                ></b-carousel-slide>

                <b-carousel-slide
                  img-src="https://user-images.githubusercontent.com/8843150/62485829-d3026f00-b78b-11e9-89f2-0b8073ea3aee.png"
                ></b-carousel-slide>

                <b-carousel-slide
                  img-src="https://user-images.githubusercontent.com/8843150/62485852-dd246d80-b78b-11e9-8605-2acbd651d59e.png"
                ></b-carousel-slide>
              </b-carousel>
            </div>
          </div>

          <div
            class="row row-grid py-4"
            data-aos="fade-left"
          >
            <div
              class="col-lg-6 order-sm-0 order-md-0"
              style="vertical-align: middle;"
            >
              <h1 class="text-primary display-2">Find and access your data instantly</h1>
              <p
                class="lead"
              >Isabl's frontend enables instant queries across the entire data capital. The Patient Tree View offers access across all digital assets available for each patient. Raw data queries are enabled through IGV.js whilst rendering of application results is supported for multiple formats.</p>
            </div>
            <div class="col-lg-6 text-center order-sm-1 order-md-1">
              <b-carousel
                id="carousel-1"
                v-model="slide"
                controls
                indicators
                background="transparent"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
                :interval="null"
              >
                <b-carousel-slide
                  img-src="https://user-images.githubusercontent.com/8843150/62553763-ee2db700-b83d-11e9-8bed-85be38d51866.png"
                ></b-carousel-slide>

                <b-carousel-slide
                  img-src="https://user-images.githubusercontent.com/8843150/62553932-3cdb5100-b83e-11e9-858d-523366b30d53.png"
                ></b-carousel-slide>
              </b-carousel>
            </div>
          </div>

          <div
            class="row row-grid py-4"
            data-aos="fade-right"
          >
            <div class="col-lg-6 order-sm-0 order-md-1">
              <h1 class="text-primary display-2">Build data-driven automations</h1>
              <p
                class="lead"
              >By implementing event-based signals, you can automate advanced data science workflows: sync metadata from clinical databases, automatically import and link data, deploy tools, and produce aggregated reports that can meaningfully impact your operations.</p>
            </div>

            <div class="col-lg-6 text-center order-sm-1 order-md-0">
              <img
                class="img-center img-fluid"
                src="https://user-images.githubusercontent.com/8843150/62807638-d49da100-bac3-11e9-8ad3-286804fc7140.png"
              />
              <!-- This is the no click genome image -->
              <!-- src="https://user-images.githubusercontent.com/8843150/62487171-2aeea500-b78f-11e9-81f2-a51f695132e4.png" -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Fair/Data Principles -->
    <section
      class="section section-shaped my-0 pt-100 overflow-hidden"
      style="padding-bottom: 10rem"
    >
      <div
        class="shape shape-style-3 bg-black shape-skew"
        style="height: 100%"
      ></div>
      <div class="row text-center justify-content-center">
        <div class="col-lg-10">
          <h2 class="display-1 text-white">Why Isabl?</h2>
          <p
            class="lead text-white py-5"
          >Isabl Platform ensures that all bioinformatics operations follow the DATA reproducibility checklist (Documentation, Automation, Traceability, and Autonomy; Kenall, et al. 2015 ), whilst guarantees to a great extent that assets are managed according to the FAIR principles (Findable, Interoperable, Accessible, Reusable; Wilkinson et al. 2016).</p>

          <div
            class="container"
            data-aos="zoom-in"
            data-duration="500"
            data-aos-delay="200"
            style="padding-bottom: 400px"
          >
            <img
              class="img-center img-fluid"
              src="https://user-images.githubusercontent.com/8843150/62487193-393cc100-b78f-11e9-8006-8110531049af.png"
            />
            <!-- style="padding-bottom: 550px" -->
          </div>
        </div>
      </div>
    </section>

    <!-- Scalability Numbers -->
    <section
      class="section section-shaped my-0 overflow-hidden"
      style="margin-top: -500px !important; padding-top: 200px;"
    >
      <div
        class="shape shape-style-3 bg-gradient-isabl shape-skew"
        style="transform-origin: right; background-color: white"
      ></div>
      <div class="row text-center justify-content-center">
        <div class="col-lg-10">
          <h1 class="display-1 text-white">Isabl Platform Scalability</h1>
          <p
            class="lead text-white py-5"
          >Since 2016, Isabl Platform has served as the backbone of the Pediatrics Precision Medicine Initiative and the Center of Heme Malignancies at Memorial Sloan Kettering Cancer Center. The system has supported bioinformatics operations across:</p>
        </div>
      </div>
      <div
        class="container"
        style="padding-bottom: 400px"
      >
        <div class="row row-grid text-center">
          <div class="col-lg-4">
            <h1 class="large-text text-white">
              <animated-number
                :number="300"
                :duration="80"
              />
            </h1>
            <h5 class="text-white">Projects</h5>
            <p class="text-white">In Papaemmanuil Lab, CHM, Pediatrics.</p>
          </div>
          <div class="col-lg-4">
            <h1 class="large-text text-white">
              <span>+</span>
              <animated-number
                :number="70"
                :duration="150"
                :change="2"
              />K
            </h1>
            <h5 class="text-white">Samples</h5>
            <p class="text-white">Across multiple species, tumor types and genders</p>
          </div>
          <div class="col-lg-4">
            <h1 class="large-text text-white">
              <span>+</span>
              <animated-number
                :number="700"
                :duration="80"
              />K
            </h1>
            <h5 class="text-white">Analyses</h5>
            <p class="text-white">Producing results for more than 30 types of applications</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section
      class="section section section-shaped my-0 overflow-hidden"
      style="margin-top: -300px !important; padding-top: 0px"
    >
      <div
        class="shape shape-style-1 shape-skew"
        style="transform-origin: right; background-color: #F6F9FC"
      ></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <card
              gradient="secondary"
              shadow
              body-classes="p-lg-4"
              color="white"
            >
              <h4 class="display-4 my-0 pb-3 text-center">Frequently Asked Questions</h4>

              <div
                class="accordion"
                id="accordionFAQ"
              >
                <div class="card">
                  <div
                    class="card-header"
                    id="headingReasons"
                  >
                    <h5 class="mb-0">
                      <button
                        style="white-space: normal;"
                        class="btn btn-link"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseReasons"
                        aria-expanded="true"
                        aria-controls="collapseReasons"
                      >Is Isabl right for me?</button>
                    </h5>
                  </div>

                  <div
                    id="collapseReasons"
                    class="collapse"
                    aria-labelledby="headingReasons"
                    data-parent="#accordionFAQ"
                  >
                    <div class="card-body px-5">
                      <ul class="list-unstyled text-center">
                        <li
                          class="py-2"
                          v-for="i in reasonsForIsabl"
                          :key="i"
                        >
                          <div class="d-flex align-items-center">
                            <font-awesome-icon
                              icon="check"
                              class="mr-4 text-success"
                            />
                            <p class="mb-0">{{i}}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  class="card"
                  v-for="(i, index) in FAQ"
                  :key="index"
                >
                  <div
                    class="card-header"
                    :id="`heading${index}`"
                  >
                    <h5 class="mb-0">
                      <button
                        style="white-space: normal;"
                        class="btn btn-link"
                        type="button"
                        data-toggle="collapse"
                        :data-target="`#collapse${index}`"
                        aria-expanded="true"
                        :aria-controls="`collapse${index}`"
                      >{{i.q}}</button>
                    </h5>
                  </div>

                  <div
                    :id="`collapse${index}`"
                    class="collapse"
                    :aria-labelledby="`heading${index}`"
                    data-parent="#accordionFAQ"
                  >
                    <div class="card-body px-5">
                      <p>
                        <span v-html="i.a"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>

    <hr class="my-0" />
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue";
import { BCarouselSlide } from "bootstrap-vue";
import { BCollapse } from "bootstrap-vue";
import AnimatedNumber from "../custom/AnimatedNumber";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  name: "home",
  components: {
    AnimatedNumber,
    BCarousel,
    BCarouselSlide,
    BCollapse,
    Tabs,
    TabPane,
  },
  data() {
    const requestAccess = {
      to: "licenses@isabl.io",
      cc: "papaemme@mskcc.org",
      subject: "[ACTION REQUIRED] Isabl Instance Request",
      body: `Best regards,%0A%0AI would like to have access to Isabl. Here is some information about my institution: %0A%0A<Your Institution>%0A<For-profit or Non-profit?>%0A<One sentence of intended use>`,
    };

    return {
      links: {
        onlineDemo: "http://bit.ly/isabl-demo",
        quickStart: "https://isabl.gitbook.io/docs/quick-start",
        requestAccess: `mailto:${requestAccess.to}?cc=${requestAccess.cc}&subject=${requestAccess.subject}&body=${requestAccess.body}`,
      },
      reasonsForIsabl: [
        "You don't have a +10 engineers group but do have hundreds of samples",
        "You'll rather not have your data managed by postdocs, PhD students",
        "Crosslink samples from different cohorts",
        "Answer new questions using existing data",
        "Full log and audit trail of your informatics operations",
        "Automatically merge results as new samples are added to big cohorts",
        "You want to have programmatic access to the entire data capital",
        "Seamlessly run reproducible pipelines across your projects",
      ],
      FAQ: [
        {
          q: "What is Isabl not trying to do?",
          a: `<ul> <li><p>Isabl is not a <b>Workflow Management System</b> such as <a href="https://github.com/DataBiosphere/toil">Toil</a>, <a href="https://github.com/ssadedin/bpipe">Bpipe</a>, instead Isabl facilitates automated deployment and databasing of data processing pipelines.</p></li> <li><p>Isabl is not a <b>Platform as a Service (PAAS)</b> provider such as <a href="https://www.dnanexus.com">DNA nexus</a>, <a href="https://www.sevenbridges.com">Seven Bridges</a> or <a href="https://software.broadinstitute.org/firecloud/">Fire Cloud</a>, instead an information system that could potentially feed in metadata and data to these services. </p></li> <li><p>Isabl differs from <b>Server Workbenches</b> such as <a href="https://usegalaxy.org/">Galaxy</a> or Pegasus, instead of being configuration friendly, Isabl is designed to conduct systematic analyses automatically and in a standardized way with as little human input as possible. </p></li> <li><p>Isabl is not a <b>Workflow Language</b>, instead the Bioinformatics Applications in <code>Isabl</code> only define meta-data driven validation and logic to build commands to trigger pipelines written in any language.</p></li> </ul>`,
        },
        {
          q: "How does Isabl compare to other solutions?",
          a: `<p>These are some projects that are similar to Isabl:</p> <ul><li><p><a href="https://github.com/genome/gms">The Genome Modeling System</a> <em>Genome Institute at Washington University platform.</em></p></li> <li><p><a href="https://seqware.github.io/">SeqWare</a> <em>analyze massive genomics datasets.</em></p></li> <li><p><a href="http://bifacility.uni-koeln.de/quickngs/web/">QuickNGS</a> <em>efficient high-throughput data analysis of Next-Generation Sequencing data.</em></p></li> <li><p><a href="https://github.com/arnaudceol/htsflow">HTS-flow</a> <em>a framework for the management and analysis of NGS data.</em></p></li></ul><br><img width="100%" class="img-center img-fluid" tabindex="0" src="https://docs.google.com/drawings/d/e/2PACX-1vQVWp-apNN4GsWf4QYX2fidVlHwz7--kH3ByiWpWltANkHgZOpyxTdVlOlPvh6bT13no-N_1LaG174D/pub?w=937&h=1067" /><br><p><em>Please contact us if you think this comparison needs to be updated.</p></em>`,
        },
        {
          q: "Is Isabl shipped with ready-to-go Bioinformatic Applications?",
          a: `Isabl does not include pre-built applications. Keeping analytical logic separate from infrastructure logic results in a more testable, leaner, and future-proof platform. Building an individual-centric data capital is more important than today's analytical and experimental approaches. Processing data pipelines and reference and control datasets are continuosuly evolving. As tools evolve, keeping analytical logic separate from infrastructure logic ensures a future-proof platform.<br /><br />Nevertheless, our <a href="/docs/quick-start">10-minutes quick start</a> demo comes with some example applications.`,
        },
        {
          q: "Does Isabl work on the cloud?",
          a: `Although Isabl does not come with cloud support out of the box, the data import logic to support cloud storage and application execution into cloud batch systems can be extended and customized seamlessly. Some of our users are using Isabl in cloud systems like Microsoft Azure.
        `,
        },
        {
          q: "What kind of employees do I need to run an instance of Isabl?",
          a: `You will need at least +1 engineer with software engineering knowledge, to understand how Isabl services are deployed and work. Someone that's in charge of the production instance and database support (See <a href="/docs/production-deployment">Production Deployment</a>), such as managing backups, monitoring the backend instance, patching client settings, creating/updating database models, changing users permissions and roles, and <a href="/docs/operational-automations">setting up automated workflows</a>.<br /><br />Your engineer(s) or technical team should be familiar with technologies like django, postgres (SQL), docker and javascript, depending on how much customization and extendibility you may want to add to your Isabl instance.<br /><br />To write new applications to embed within Isabl, anyone can do it by defining a python Abstract Class. More info see<a href="/docs/writing-applications">how to write Isabl Applications.</a>`,
        },
        {
          q: "Can Isabl run in a clinical setting?",
          a: `Isabl is not HIPAA compliant, and was developed mainly for research purposes where data can be stored anonymized with non-PHI (Protected Health Information) patient metadata. Nonetheless, its design allows to extend the database schema and api integration with clinical systems. You may need to audit your internal process and where you deploy your Isabl instances. We developed Isabl, mainly using mature open-source mature projects complying with the <a href="https://12factor.net/">12-factor app guidelines</a> on ideal practices for app development.`,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
*:focus {
  outline: none;
}
.circle {
  height: 150px;
  width: 150px;
  background-color: transparent;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.circle .icon i {
  font-size: 60px;
  margin-top: 45px;
}

.circle .icon-shape {
  vertical-align: super;
}

.circle p {
  margin: 0px;
  font-size: 20px;
  color: white;
  font-weight: 800;
}

.super-large-text {
  font-size: 160px;
  margin: 0px;
}
.large-text {
  font-size: 80px;
  margin: 0px;
}

.bg-black {
  background: black;
}

.large-icon i {
  font-size: 40px;
}

.feature-section {
  margin-top: -236px !important;
}

.inline-text {
  display: inline-block;
  vertical-align: middle;
}

@media (min-width: 992px) {
  section .row {
    max-width: 1500px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}

.elevation-medium {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
}

.elevation-high {
  box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.2),
    0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12) !important;
}
</style>
